// extracted by mini-css-extract-plugin
export default {"videoPanel":"VideoPanel_videoPanel__k4oCK","fill":"VideoPanel_fill__654kl"};